module.exports = __webpack_public_path__ + "static/media/ΠΡΟΤΥΠΟ ΑΦΙΣΑ_1.c4bf38e7.vtt";